import axios from 'utils/bsac-api.js';
import conversions from 'utils/conversions.js';
import environments from 'constant/environments.js';
import selections from 'constant/selections.js';

const state = {
  products: [],
};

const getters = {
  /**
   * 商品情報を取得する
   * @param {*} state
   * @returns 商品
   */
  product: (state) => (id) => {
    let products = state.products.filter((product) => {
      return product.id === id;
    });
    return products.length > 0 ? products[0] : null;
  },
  /**
   * 商品詳細を取得する
   * @param {*} state
   * @returns 商品
   */
  productDetail: (state, getters) => (id) => {
    const product = getters.product(id);
    if (!product) return null;

    return `■ 商品番号: ${product.productNo ? product.productNo : ''}
    ■ 定価: ${product.listPriceJpy ? product.listPriceJpy : ''}
    ■ 販売価格（税込）: ${product.sellingPriceJpy ? product.sellingPriceJpy : ''}
    ■ カラー: ${product.colorJa ? product.colorJa : ''}
    ■ サイズ: ${product.sizeJa ? product.sizeJa : ''}
    ■ 商品説明:
    ${product.description ? product.description : ''}`;
  },
  /**
   * 商品概要を取得する
   * @param {*} state
   * @returns 商品
   */
  productSummary: (state, getters) => (id) => {
    const product = getters.product(id);
    if (!product) return null;

    return `${
      product.nameJa
        ? product.nameJa.length > 20
          ? product.nameJa.substr(0, 20) + '...'
          : product.nameJa
        : ''
    }
      ■ 商品番号: ${product.productNo ? product.productNo : ''}
      ■ 定価: ${product.listPriceJpy ? product.listPriceJpy : ''}
      ■ 販売価格（税込）: ${product.sellingPriceJpy ? product.sellingPriceJpy : ''}
      ■ カラー: ${
        product.colorJa
          ? product.colorJa.length > 15
            ? product.colorJa.substr(0, 15) + '...'
            : product.colorJa
          : ''
      }
      ■ サイズ: ${
        product.sizeJa
          ? product.sizeJa.length > 15
            ? product.sizeJa.substr(0, 15) + '...'
            : product.sizeJa
          : ''
      }`;
  },
  /**
   * 商品一覧を取得する
   * @param {*} state
   * @returns 商品一覧
   */
  products: (state) => state.products,
  /**
   * カテゴリーIDを条件に商品一覧を取得する
   * @param {*} state
   * @returns
   */
  productsByCategory: (state) => (categoryId) => {
    if (categoryId === selections.notSelected) return state.products;
    return state.products.filter(function (product) {
      return product.productCategoryId === categoryId;
    });
  },
};

const mutations = {
  /**
   * 商品一覧をセットする
   * @param {*} state
   * @param {*} products
   */
  setProducts(state, products) {
    state.products = [];
    products.forEach(function (product) {
      let convertedProduct = conversions.toCamelCaseForObject(product);
      // サムネイルファイル名からURLを生成
      convertedProduct[
        'thumbnailUrl'
      ] = `${environments.shoppingApiUrl}/product_images/${convertedProduct.thumbnailFileName}`;
      // 画像ファイル名リストから画像URLリストを生成
      let imageUrls = [];
      convertedProduct.imageFileNames.forEach(function (fileName) {
        imageUrls.push(`${environments.shoppingApiUrl}/product_images/${fileName}`);
      });
      convertedProduct['imageUrls'] = imageUrls;
      state.products.push(convertedProduct);
    });
  },
};

const actions = {
  /**
   * APIを呼び出し商品一覧を取得する
   * @param {*} param0
   * @param {*} state
   * @returns
   */
  getProducts({ commit, rootGetters }) {
    const headers = rootGetters['partner/authHeaders']
      ? { headers: rootGetters['partner/authHeaders'] }
      : null;
    // console.log(`header: ${JSON.stringify(headers)}`);
    return axios
      .get(`${environments.shoppingApiUrl}/products`, headers)
      .then((response) => {
        // console.debug('response:' + JSON.stringify(response));
        commit('setProducts', response.data.data);
        return {
          success: true,
        };
      })
      .catch((error) => {
        console.error(error.response);
        return {
          success: false,
        };
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
